<template>
    <div class="pageBox">
        <div class="slideRow">
            <div class="nav_category"></div>
            <div class="slide block">
                <el-carousel height="480px">
                    <el-carousel-item
                        class="item_slide"
                        v-for="(item,index) in slideList.slice(0,5)"
                        :key="index">
                        <a :href="item.linkurl" target="_blank">
                            <img :src="item.imgurl"/>
                        </a>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="serveBox hide">
            <div class="titleRow">
                <div class="titleBox">
                    <span>咨询服务</span>
                </div>
                <div class="more">查看更多>></div>
            </div>
        </div>
        <div class="serveBox hide">
            <div class="titleRow">
                <div class="titleBox">
                    <span>检验服务</span>
                </div>
                <div class="more">查看更多>></div>
            </div>
            <div class="slide_two block">
                <el-carousel height="400px" indicator-position="none">
                    <el-carousel-item class="item_slide" v-for="(item,index) in slideList_two" :key="index">
                        <div class="slide_item_Box">
                            <div class="imgBox">
                                <img src="../assets/images/logo.png" alt="">
                            </div>
                            <div class="cateBox">
                                <div class="title">{{ item.title }}</div>
                                <div class="imgBox">
                                    <img src="../assets/images/logo.png" alt="">
                                </div>
                                <div class="info">{{ item.info }}</div>
                            </div>
                            <div class="cateBox">
                                <div class="title">{{ item.title }}</div>
                                <div class="imgBox">
                                    <img src="../assets/images/logo.png" alt="">
                                </div>
                                <div class="info">{{ item.info }}</div>
                            </div>
                        </div>
                        <div class="slide_item_Box">
                            <div class="imgBox">
                                <img src="../assets/images/logo.png" alt="">
                            </div>
                            <div class="cateBox">
                                <div class="title">{{ item.title2 }}</div>
                                <div class="imgBox">
                                    <img src="../assets/images/logo.png" alt="">
                                </div>
                                <div class="info">{{ item.info2 }}</div>
                            </div>
                            <div class="cateBox">
                                <div class="title">{{ item.title2 }}</div>
                                <div class="imgBox">
                                    <img src="../assets/images/logo.png" alt="">
                                </div>
                                <div class="info">{{ item.info2 }}</div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="serveBox" v-for="(item,index) in serveList" :key="index" v-show="item.secondService.length>0">
            <div class="titleRow">
                <div class="titleBox">
                    <span>{{ item.serivceTypeName }}</span>
                </div>
                <router-link
                    :to="{name:'ServeList',params: {stId:item.id}}"
                    class="more">
                    查看更多>>
                </router-link>
            </div>
            <div class="itemBox">
                <router-link :to="{name:'ServeDetail',params: {sId:unit.id}}"
                     class="item"
                     v-for="(unit,ind) in item.secondService"
                     :key="ind">
                    <div class="imgBox">
                        <img :src="unit.serviceImg" :alt="unit.title">
                    </div>
                    <div class="title">{{ unit.title }}</div>
                    <div class="separate"></div>
                    <div class="info">{{ unit.subTitle }}</div>
                    <div class="more">查看更多》</div>
                </router-link>
            </div>
        </div>
        <div class="serveBox">
            <div class="titleRow">
                <div class="titleBox">
                    <span>中安新闻</span>
                </div>
                <router-link to="/Resource" class="more">查看更多>></router-link>
            </div>
            <div class="newsBox">
                <router-link
                    :to="{name:'NewsDetail',params:{nId:item.id}}"
                    class="item"
                    v-for="(item,index) in news"
                    :key="index">
                    <div class="imgBox">
                        <img :src="item.newsImg" :alt="item.newsTitle">
                    </div>
                    <div class="conBox">
                        <div class="title">{{ item.newsTitle }}</div>
                        <div class="info">{{ item.newsInfo }}</div>
                    </div>
                </router-link>
            </div>
        </div>
        <div class="serveBox hide">
            <div class="titleRow">
                <div class="titleBox">
                    <span>中安简介</span>
                </div>
            </div>
            <div class="briefBox">
                <div class="TextBox">
                    <div class="briefText">
                        中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介中安简介
                    </div>
                    <div class="more">查看更多>></div>
                </div>
                <video class="briefVideo">
                    视频位置
                </video>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "index",
    data() {
        return {
            slideList: [],
            slideList_two: [
                {
                    imgPath: '',
                    title: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题',
                    info: '简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介',
                    imgPath2: '',
                    title2: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题',
                    info2: '简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介',
                },
                {
                    imgPath: '',
                    title: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题',
                    info: '简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介',
                    imgPath2: '',
                    title2: '标题标题标题标题标题标题标题标题标题标题标题标题标题标题标题',
                    info2: '简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介简介',
                }
            ],
            //服务列表
            serveList: [],
            news: []
        }
    },
    mounted() {
        document.title = '中安检测'
        this.$store.commit('setNav', 1)
        this.$store.commit('setIndex', true)
        this.$store.commit('setFloatCategory', true)
        this.getIndexData()
        this.getSlide()
    },
    methods: {
        /**
         * 获取首页数据
         */
        getIndexData() {
            this.$get('/V1/Index/Index', {})
                .then((res) => {
                    // console.log('Index', res)
                    if (res.success) {
                        this.news = res.response.news
                        this.serveList = res.response.children
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        },

        /**
         * 获取首页轮播
         */
        getSlide() {
            this.$post('/V1/IndexImgs/GetImgs', {})
                .then((res) => {
                    // console.log('slide', res)
                    if (res.success) {
                        this.slideList = res.response
                    } else {
                        this.$message.error("网络错误，请重试");
                    }
                })
                .catch(() => {
                    this.$message.error("网络错误，请重试");
                })
        }
    },
    destroyed() {
        this.$store.commit('setIndex', false)
        this.$store.commit('setFloatCategory', false)
    }
}
</script>

<style scoped lang="less">
.pageBox {
    display: flex;
    flex-direction: column;

    .slideRow {
        display: flex;
        flex-direction: row;
        width: 1200px;
        margin: 0 auto;

        .nav_category {
            width: 238px;
            height: 478px;
            background-color: red;
            border: 1px solid #1f2d5c;
        }

        .slide {
            width: 960px;
            height: 480px;

            .item_slide {

                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .serveBox {
        display: flex;
        flex-direction: column;
        width: 1210px;
        margin: 10px auto 20px;

        .titleRow {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin: 10px 0px;

            .titleBox {
                display: flex;
                flex-direction: row;
                align-items: center;

                img {

                }

                span {
                    font-weight: bold;
                    color: #1f2d5c;
                    font-size: 24px;
                }
            }

            .more {
                font-size: 14px;
                color: #666;
                display: block;
                padding-right: 20px;
                line-height: 30px;
                cursor: pointer;
            }

            .more:hover {
                padding-right: 0px;
                padding-left: 20px;
                transition: .5s;
            }
        }

        .itemBox {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 1210px;

            .item {
                display: flex;
                flex-direction: column;
                align-items: center;
                border: 1px solid #e0e0e0;
                width: 290px;
                height: 332px;
                margin-top: 10px;

                .imgBox {
                    width: 290px;
                    height: 145px;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .title {
                    font-size: 18px;
                    color: #1f2d5c;
                    margin: 15px 0px;
                    width: 90%;
                    text-align: center;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .separate {
                    width: 80px;
                    height: 5px;
                    background-color: #e0e0e0;
                    border-radius: 5px;
                    margin-top: 10px;
                }

                .info {
                    text-align: center;
                    width: 280px;
                    font-size: 13px;
                    color: #999;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin: 20px 0px 10px;
                }

                .more {
                    border: 1px solid #ccc;
                    border-radius: 5px;
                    padding: 9px 20px;;
                    color: #666;
                    font-size: 14px;
                }

                .more:hover {
                    transition: .5s;
                    background-color: #1f2d5c;
                    color: white;
                }
            }

            .item:hover {
                background-color: #f9f9f9;
                margin-top: 8px;
                transition: .3s;
                box-shadow: 0 0 10px 0 #ccc;
            }
        }

        .slide_two {

            .item_slide {
                display: flex;
                flex-direction: row;

                .slide_item_Box {
                    width: 605px;
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;

                    .imgBox {
                        width: 200px;
                        height: 400px;

                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }

                    .cateBox {
                        width: 190px;
                        border: 2px solid #e5e5e5;
                        box-shadow: 0px 0px 5px 2px #eee;
                        border-left: none;
                        border-radius: 8px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;

                        .imgBox {
                            width: 190px;
                            height: 190px;
                            margin: 10px 0px;

                            img {
                                width: 100%;
                                height: 100%;
                            }
                        }

                        .title {
                            width: 185px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            line-height: 24px;
                            font-size: 20px;
                            color: #1f2d5c;
                            margin: 10px 0px 20px 0px;
                        }

                        .info {
                            width: 185px;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            font-size: 15px;
                            color: #999;
                            margin: 5px 0px;
                        }
                    }
                }
            }

        }

        .newsBox {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            width: 100%;
            margin-bottom: 20px;

            .item {
                display: flex;
                flex-direction: row;
                width: 580px;
                height: 130px;
                overflow: hidden;
                padding: 10px;

                .imgBox {
                    width: 260px;
                    min-width: 260px;
                    height: 130px;
                    min-height: 130px;
                    margin-right: 10px;
                    border: 1px solid #e7e7e7;

                    img {
                        width: 100%;
                        height: 100%;
                    }
                }

                .imgBox:hover {
                    box-shadow: 0px 2px 6px 2px #bdbdbd;
                    transition: .3s;
                }

                .conBox {
                    display: flex;
                    flex-direction: column;

                    .title {
                        color: #1f2d5c;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 2;
                        overflow: hidden;
                        font-size: 18px;
                        margin-bottom: 10px;
                    }

                    .info {
                        color: #999;
                        display: -webkit-box;
                        -webkit-box-orient: vertical;
                        -webkit-line-clamp: 3;
                        overflow: hidden;
                        font-size: 14px;
                        line-height: 20px;
                    }
                }
            }
        }

        .briefBox {
            display: flex;
            flex-direction: row;
            justify-content: space-between;

            .TextBox {
                display: flex;
                flex-direction: column;

                .briefText {
                    width: 500px;
                    height: 250px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 12;
                    overflow: hidden;
                }

                .more {
                    border: 1px solid #7b7b7b;
                    height: 40px;
                    line-height: 40px;
                    width: 120px;
                    text-align: center;
                    color: #7b7b7b;
                    margin-top: 50px;
                    cursor: pointer;
                }

                .more:hover {
                    background-color: #1f2d5c;
                    color: white;
                    transition: .5s;
                }
            }

            .briefVideo {
                width: 680px;
                height: 400px;
            }
        }
    }
}
</style>
